import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import Button from '../common/Button';

const DeleteConfirmationPopup = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div
      className="modal-backdrop"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-dialog-title"
    >
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <h2
            id="delete-dialog-title"
            className="font-display text-xl font-semibold mb-3 text-text-primary"
          >
            {t('deleteConfirmationPopup.title')}
          </h2>
          <p className="mb-6 text-text-secondary">
            {t('deleteConfirmationPopup.message')}
          </p>
          <div className="flex justify-end gap-3">
            <Button
              variant="tertiary"
              size="md"
              onClick={onCancel}
            >
              {t('deleteConfirmationPopup.cancel')}
            </Button>
            <Button
              variant="danger"
              size="md"
              onClick={onConfirm}
            >
              {t('deleteConfirmationPopup.delete')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationPopup;
